<dc-top-bar [@sliding]="'on'" [view]="view"></dc-top-bar>

<router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>


